import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify, {
  theme: {
    primary: '#D3C3BC',
    secondary: '#BFADA5',
    accent: '#D8EBF1',
    info: '#869b36'
  },
  iconfont: 'mdi'
})
